import { ArrowRight } from "lucide-react";

export default function QuoteCTA({ onBook }) {
  return (
    <section data-testid="quote-cta" className="relative overflow-hidden bg-black text-white">
      <div className="absolute inset-0 grain opacity-50" />
      <div className="pc-container relative z-10 grid grid-cols-1 items-end gap-10 py-20 md:grid-cols-12 md:py-28">
        <div className="md:col-span-8">
          <div className="eyebrow text-[var(--pc-green)]">No fixed pricing</div>
          <h2 className="font-display mt-3 text-4xl font-black leading-[0.95] tracking-tighter sm:text-6xl md:text-7xl">
            Every space is different.{" "}
            <span className="text-[var(--pc-green)]">Your quote should be too.</span>
          </h2>
          <p className="mt-6 max-w-xl text-lg text-white/70">
            Skip the cookie-cutter calculators. We send a real human to scope
            your space and quote it honestly — free, no obligation.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <button
            data-testid="quote-cta-button"
            onClick={onBook}
            className="pc-btn-primary text-base"
          >
            Request Custom Quote <ArrowRight size={18} />
          </button>
          <p className="mt-3 text-sm text-white/50 md:text-right">
            Same-week availability across the GTA.
          </p>
        </div>
      </div>
    </section>
  );
}
